import { render, staticRenderFns } from "./ModalDailyLimitError.vue?vue&type=template&id=0594baf1&"
import script from "./ModalDailyLimitError.vue?vue&type=script&lang=js&"
export * from "./ModalDailyLimitError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports